import St from '../../screens/LoginScreen/LoginScreen.module.css';

const Button = ({ loading, disabled, label, type, onClick }) => {
  return (
    <button type={type} className={`${St.btnSubmit} ${loading ? St.btnLoading : ''}`} disabled={disabled} onClick={onClick}>
      <span className={St.btnLabel}>{label}</span>
    </button>
  );
};

export default Button;
